import { Component, Input, OnInit } from '@angular/core';
import { BookingService } from '../booking/booking.service';
import { GlobalService } from 'app/shared/global.service';
import { PaymentGatewayService } from '../booking-login/payment-gateway.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit {


  @Input() CarmePaymentGateway_key: string = '';
  @Input() CarmePaymentGateway_secret: string = '';
  @Input() selectedOnlinePatientRegistrationID: number = 0;
  PaymentHistory = [];
  GuestHistory = [];
  //isPaymentHistory = false;
  isInProgress = false;
  page = 1;
  filters: string = '';
  messages = {};
  // datePipe = new DatePipe("en-US");

  constructor(public bookingService: BookingService,
    private toasterService: ToastrService,
    private paymentGatewayService: PaymentGatewayService,
    public globals: GlobalService) { }

  // Getting Payment History by OnlinePatientRegistrationID
  GetPaymentHistory(OnlinePatientRegistrationID) {
    this.PaymentHistory = [];
    this.globals.isPaymentHistory = true;
    this.bookingService.GetPaymentHistory(OnlinePatientRegistrationID).subscribe((data) => {
      if (data.length > 0) {
        this.GuestHistory = data[0];
        this.PaymentHistory = data[1];
      }
    });
  }

  paymentDetails: any;
  orderDetails: any;
  customDetails: any;

  //getting razorpay payment history
  GetPaymentAndOrderDetails(PaymentID, ThirdpartyPaymentID, ThirdpartyPaymentOrderID) {
    if (ThirdpartyPaymentID != "" && ThirdpartyPaymentID != null) {
      this.paymentGatewayService.GetPaymentAndOrderDetails(ThirdpartyPaymentID, ThirdpartyPaymentOrderID, this.CarmePaymentGateway_key, this.CarmePaymentGateway_secret).subscribe((data) => {
        if (data != null && data != "") {
          // Convert string response to JSON object if needed
          const jsonData = typeof data === "string" ? JSON.parse(data) : data;
          let result = this.PaymentHistory.filter((x) => x["PaymentID"] == PaymentID);
          console.log(result);
          const customDetails = {
            Name: result[0].GuestName,
            "Payment Date/Time": result[0].PaymentDate,
            Type: result[0].Type,
            "Product Info": result[0].ProductInfo,
            "Amount (Rs.)": this.PaymentHistory[0].AdvBookingAmt,
            Phone: result[0].MobileNo,
            Email: result[0].Email,
            "Service Provider": "Razorpay",
            Status: "Payment used-up"
          };

          // Store updated details
          this.paymentDetails = jsonData.payment;
          this.orderDetails = jsonData.order;
          this.customDetails = customDetails
          this.globals.isPaymentDetails = true;

        }
      });
    }
  }




  ngOnInit(): void {
    this.GetPaymentHistory(this.selectedOnlinePatientRegistrationID);
    this.globals.isPaymentDetails = false;
  }

  GetBack() {
    // Hide payment History
    if (this.globals.isPaymentHistory && this.globals.UserName != "" && !this.globals.isPaymentDetails) {
      this.globals.isPaymentHistory = false;
    }
    // Hide payment details and show 
    else if (this.globals.isPaymentHistory && this.globals.UserName != "" && this.globals.isPaymentDetails) {
      this.globals.isPaymentHistory = true;
      this.globals.isPaymentDetails = false;
    }
  }
}
